import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { OrganizerFedLandingPageComponent } from '~/organizer/components/pages/fed-landing-page/fed-landing-page.component';
import { OrganizationChoicePageComponent } from '~/organizer/components/pages/organization-choice-page/organization-choice-page.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./activity/activity.module').then(
        (m) => m.OrganizerActivityModule
      ),
    data: { discriminantPathKey: 'ORGANIZER_ACTIVITY' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./activity-creation/activity-creation.module').then(
        (m) => m.OrganizerActivityCreationModule
      ),
    data: { discriminantPathKey: 'ACTIVITY_CREATION' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./activity-planning/activity-planning.module').then(
        (m) => m.OrganizerActivityPlanningModule
      ),
    data: { discriminantPathKey: 'ACTIVITY_PLANNING' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./activity-sharing/activity-sharing.module').then(
        (m) => m.OrganizerActivitySharingModule
      ),
    data: { discriminantPathKey: 'ACTIVITY_SHARING' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./activity-edition/activity-edition.module').then(
        (m) => m.OrganizerActivityEditionModule
      ),
    data: { discriminantPathKey: 'ACTIVITY_EDITION' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./planning/planning.module').then((m) => m.PlanningModule),
    data: { discriminantPathKey: 'ORGANIZER_PLANNING' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./payout-invoices/payout-invoices.module').then(
        (m) => m.PayoutInvoicesModule
      ),
    data: { discriminantPathKey: 'ORGANIZER_PAYOUT_INVOICES' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./qr-code-validation/qr-code-validation.module').then(
        (m) => m.QrCodeValidationModule
      ),
    data: { discriminantPathKey: 'ORGANIZER_QR_CODE_VALIDATION' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./messaging/messaging.module').then(
        (m) => m.OrganizerMessagingModule
      ),
    data: { discriminantPathKey: 'ORGANIZER_MESSAGING' },
  },
  {
    path: '',
    loadChildren: () =>
      import('./timeslot/timeslot.module').then(
        (m) => m.OrganizerTimeslotModule
      ),
    data: { discriminantPathKey: 'ORGANIZER_TIMESLOT' },
  },

  {
    path: '',
    loadChildren: () =>
      import('./timeslot-edition/timeslot-edition.module').then(
        (m) => m.OrganizerTimeslotEditionModule
      ),
    data: { discriminantPathKey: 'TIMESLOT_EDITION' },
  },
  {
    path: 'organizer.fed-landing',
    component: OrganizerFedLandingPageComponent,
  },
  {
    path: 'organizer.organization-choice',
    component: OrganizationChoicePageComponent,
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerRoutingModule {}
